import { dropsToXrp, xrpToDrops } from 'xrpl/dist/npm'
import { XrplCurrency, XrplAmount } from './types'

export const toXrplAsset = (currency: XrplCurrency) => {
  if (currency.isNative || currency.currency === 'XRP') {
    return { currency: 'XRP' }
  }

  if (!currency.issuer) {
    throw new Error(`Missing issuer for ${currency.symbol}`)
  }

  return {
    currency: currency.currency,
    issuer: currency.issuer,
  }
}

export const toXrplAmount = (currency: XrplCurrency, value: string): XrplAmount => {
  if (currency.isNative || currency.currency === 'XRP') {
    return xrpToDrops(value)
  }

  if (!currency.issuer) {
    throw new Error(`Missing issuer for ${currency.symbol}`)
  }

  return {
    currency: currency.currency,
    issuer: currency.issuer,
    value,
  }
}

export const fromXrplAmount = (amount: XrplAmount): string => {
  if (typeof amount === 'string') {
    return dropsToXrp(amount)
  }
  return amount.value
}
